// Display-only relabeling of public.users.role. The underlying values
// ("admin" | "manager" | "member" | "owner") and every permission check built
// on them (isAdmin, canAdmin, is_admin()/is_manager_or_admin() etc., in both
// the frontend and Supabase RLS) are UNCHANGED — this only controls what a
// role reads as on screen.
// "admin" reads as "Admin" everywhere a person's role is shown to a user
// (it was relabeled "HOD" for a while; reverted on explicit request 2026-10-08).
// "owner" (added 2026-09-18) is a real account role with identical
// permissions to "manager" everywhere (see is_manager_or_admin()) — it exists
// so the fixed initiative-owners allowlist (lib/initiativeOwners.js) reads as
// "Owner" instead of "Manager"/"Member" on the Team page and everywhere else
// a role is shown.
export const ROLE_LABELS = {
  admin: "Admin",
  manager: "Manager",
  member: "Member",
  owner: "Owner",
};

export const roleLabel = (role) => ROLE_LABELS[role] || role;
